import { HttpClient, HttpHeaders } from '@angular/common/http';

import { EquipmentAir } from '../model/equipment';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class ExecutionEquipmentService {

    constructor(private http: HttpClient) {
    }

    save(eq: EquipmentAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/equipment/create/${executionId}`
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.post(url, eq, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    update(eq: EquipmentAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/equipment/${eq.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.put(url, eq, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(eq: EquipmentAir, timeStamp: string, executionId: number): Observable<any> {
        const url = environment.airUrl + `/execution/equipment/${eq.id}/${executionId}`;
        const headers = new HttpHeaders({
            timeStamp
        });
        return this.http.delete(url, { headers }).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

}
